// DO NOT CHANGE THE EXISTING VALUES. You can add new values, but you cannot change the existing values.
export enum IntegrationKind {
  Test = "test",
  Klaviyo = "klaviyo",
  Dsco = "dsco",
  Judgeme = "judgeme",
  LoyaltyLion = "loyalty-lion",
  Attentive = "attentive",
  Postscript = "postscript",
  Loop = "loop",
  Yotpo = "yotpo",
  QuickBooksOnline = "quickbooks-online",
  Stripe = "stripe",
  GoogleAnalytics = "google-analytics",
  GoogleSearchConsole = "google-search-console",
  TripleWhale = "triple-whale",
  Zonos = "zonos",
  Disputely = "disputely",
  Smile = "smile",
  Stamped = "stamped",
  Gale = "gale",
  LoopSubscriptions = "loop-subscriptions",
  Chargeflow = "chargeflow",
  Chargeblast = "chargeblast",
  Mirakl = "mirakl",
  /** Merchant-configured connections (such as an HTTPS API); `connection_kind` holds the ConnectionKind. */
  Connections = "connections",
  LinnworksCarrier = "linnworks-carrier",
  MintsoftCarrier = "mintsoft-carrier",
}
